module.exports = __webpack_public_path__ + "img/receipt.0e23facb.svg";